

export const AUTH_TOKEN = "auth_token";
export const APP_INFO = "app_info";
export const IS_DEMO = "is_demo";
export const FIRM_PATH = "firm_path";
export const USER_ID = "_us_d";
export const USER_IDENTITY = "_us_idt";
export const USER_PERMISSIONS = "_us_pr";
export const IS_SABEEAPP = "_sb_app";
export const USER_NAME_SURNAME = "_usr_n";
export const IS_BANK_USER = "_usr_is_b";